import React, { useState, useEffect, useRef } from 'react';
import { onSnapshot, collection, query, orderBy } from 'firebase/firestore';
import { db } from './firebase';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import NavigationBar from './components/Navbar';
import AllUsers from './pages/AllUsers';
import CompletedUsers from './pages/CompletedUsers';
import IncompleteUsers from './pages/IncompleteUsers';
import UserDetail from './pages/UserDetail';
import UserPage from './pages/UserPage';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import './App.css';
import { CircularProgress } from '@mui/material';
import UserForm from './components/UserForm';
import { ToastContainer } from "react-toastify";


const App = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const initialLoad = useRef(true);

  useEffect(() => {
    const q = query(collection(db, 'users'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const usersList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setUsers(usersList);
      setLoading(false);

      if (initialLoad.current) {
        initialLoad.current = false;
      }
    }, (error) => {
      console.error('Error fetching users:', error);
      setError(error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

return (
  <>
    <ToastContainer
      position="top-center"
      autoClose={2500}
      hideProgressBar={false}
      closeOnClick
      pauseOnHover
      draggable={false}
      theme="dark"
    />
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/user/:id" element={<UserPage />} />
        <Route path="/form" element={<PrivateRoute><UserForm /></PrivateRoute>} />
        <Route
          path="/*"
          element={
            loading ? (
              <div className='loading-container'>
                <CircularProgress />
              </div>
            ) : error ? (
              <div>Error: {error.message}</div>
            ) : (
              <>
                <NavigationBar />
                <Routes>
                  <Route path="/" element={<PrivateRoute><AllUsers users={users} setUsers={setUsers} /></PrivateRoute>} />
                  <Route path="/users" element={<PrivateRoute><AllUsers users={users} setUsers={setUsers} /></PrivateRoute>} />
                  <Route path="/completed" element={<PrivateRoute><CompletedUsers users={users.filter(user => user.status === 'completed')} setUsers={setUsers} /></PrivateRoute>} />
                  <Route path="/incomplete" element={<PrivateRoute><IncompleteUsers users={users.filter(user => user.status !== 'completed')} setUsers={setUsers} /></PrivateRoute>} />
                  <Route path="/:id" element={<PrivateRoute><UserDetail users={users} setUsers={setUsers} /></PrivateRoute>} />
                </Routes>
              </>
            )
          }
        />
      </Routes>
    </Router>
  </>
);
};

export default App;